import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { setSessionStorage, getSessionStorage } from '@tcp/core/src/utils/utils.web';
import { parseBoolean, getIconPath, readCookie, getViewportInfo } from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { renderLabel, getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import styles, {
  RedirectModalContainer,
  DisclaimerTextContainer,
  ButtonContainer,
  CustomButton,
} from '../styles/RedirectModal.style';

const RedirectModal = ({ className, submitCountry, updateSiteId }) => {
  const lblCountryRedirectMsg = renderLabel(
    getDynamicLabelValues('dynamic.browse_d.lbl_country_redirect_msg'),
    'lbl_country_redirect_msg'
  );

  const lblGo = renderLabel(getDynamicLabelValues('dynamic.browse_d.lbl_go_to'), 'lbl_go_to');
  const lblStay = renderLabel(getDynamicLabelValues('dynamic.browse_d.lbl_stay_in'), 'lbl_stay_in');

  const [disclaimerClosed, setDisclaimerClosed] = useState(true);

  const { isMobile } = getViewportInfo() || {};

  useEffect(() => {
    const checkDisclaimerStatus = () => {
      const isDisclaimerClosed = parseBoolean(
        getSessionStorage('country-redirection-disclaimer-closed')
      );
      setDisclaimerClosed(isDisclaimerClosed);
    };

    checkDisclaimerStatus();
  }, []);

  const handleCloseDisclaimer = () => {
    setDisclaimerClosed(true);
    setSessionStorage({ key: 'country-redirection-disclaimer-closed', value: true });
  };

  const countryCookie = readCookie('tcpCountryDetail') || 'US';
  const [shippingCountry] = readCookie('iShippingCookie')?.split('|') || '';

  const handleClick = (country) => {
    const payload = {
      language: 'en',
      savedCountry: 'US',
      savedLanguage: 'en',
      exchangevalue: '1.0',
      merchantMargin: '1.0',
    };

    const siteId = country === 'CA' ? 'ca' : 'us';

    const newPayload = {
      ...payload,
      country: country === 'CA' ? 'CA' : 'US',
      currency: country === 'CA' ? 'CAD' : 'USD',
    };
    updateSiteId(siteId);
    submitCountry(newPayload);
  };

  const countriesMap = {
    US: 'United States',
    CA: 'Canada',
  };

  const checkToShowModal = () => {
    if (
      shippingCountry &&
      countryCookie !== shippingCountry &&
      (shippingCountry?.toUpperCase() === 'US' || shippingCountry?.toUpperCase() === 'CA') &&
      (countryCookie?.toUpperCase() === 'US' || countryCookie?.toUpperCase() === 'CA')
    ) {
      return true;
    }
    return false;
  };

  const updatedLabel = lblCountryRedirectMsg
    ?.replace('##', countriesMap[shippingCountry?.toUpperCase()])
    ?.replace('$$', countriesMap[shippingCountry?.toUpperCase()]);

  return (
    !disclaimerClosed &&
    checkToShowModal() && (
      <RedirectModalContainer className={`hide-on-native-web-view ${className}`}>
        <DisclaimerTextContainer>
          <BodyCopy
            fontSize={['fs12', 'fs12', 'fs14']}
            fontWeight="semibold"
            fontFamily="secondary"
            color="black"
            className="disclaimer-text-container"
          >
            {updatedLabel}
            {isMobile && (
              <ButtonContainer
                onClick={handleCloseDisclaimer}
                onKeyDown={handleCloseDisclaimer}
                role="button"
                tabIndex={0}
                className="close-icon-container"
              >
                <img
                  alt="close"
                  className="close-icon"
                  src={getIconPath('modal-close')}
                  width={15}
                  height={15}
                />
              </ButtonContainer>
            )}
          </BodyCopy>
          <div className="btn-wrapper">
            <CustomButton className onClick={handleCloseDisclaimer}>
              {`${lblStay} ${countriesMap[shippingCountry]?.toUpperCase()}`}
            </CustomButton>
            <CustomButton primary onClick={() => handleClick(countryCookie)}>
              {`${lblGo} ${countriesMap[countryCookie]?.toUpperCase()}`}
            </CustomButton>
          </div>
        </DisclaimerTextContainer>

        {!isMobile && (
          <ButtonContainer
            onClick={handleCloseDisclaimer}
            onKeyDown={handleCloseDisclaimer}
            role="button"
            tabIndex={0}
            className="close-icon-container"
          >
            <img
              alt="close"
              className="close-icon"
              src={getIconPath('modal-close')}
              width={15}
              height={15}
            />
          </ButtonContainer>
        )}
      </RedirectModalContainer>
    )
  );
};

RedirectModal.propTypes = {
  className: PropTypes.string,
  submitCountry: PropTypes.func.isRequired,
  updateSiteId: PropTypes.func.isRequired,
};

RedirectModal.defaultProps = {
  className: '',
};

export default withStyles(RedirectModal, styles);
export { RedirectModal as RedirectModalVanilla };
